module.exports = __webpack_public_path__ + "static/media/LineGraphAlt.4fb9c384.svg";